import { render, staticRenderFns } from "./ScreensaverEditorTab.vue?vue&type=template&id=54146c0b&scoped=true"
import script from "./ScreensaverEditorTab.vue?vue&type=script&lang=js"
export * from "./ScreensaverEditorTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54146c0b",
  null
  
)

export default component.exports